"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationStatus = void 0;
__exportStar(require("./AudioSourceEvents.js"), exports);
__exportStar(require("./ConnectionEvents.js"), exports);
__exportStar(require("./ConnectionMessage.js"), exports);
__exportStar(require("./ConnectionOpenResponse.js"), exports);
__exportStar(require("./DeferralMap.js"), exports);
__exportStar(require("./DialogEvents.js"), exports);
__exportStar(require("./Error.js"), exports);
__exportStar(require("./Events.js"), exports);
__exportStar(require("./EventSource.js"), exports);
__exportStar(require("./Guid.js"), exports);
__exportStar(require("./IAudioSource.js"), exports);
__exportStar(require("./IConnection.js"), exports);
__exportStar(require("./IDetachable.js"), exports);
__exportStar(require("./IDictionary.js"), exports);
__exportStar(require("./IDisposable.js"), exports);
__exportStar(require("./IEventListener.js"), exports);
__exportStar(require("./IEventSource.js"), exports);
__exportStar(require("./IErrorMessages.js"), exports);
__exportStar(require("./ITimer.js"), exports);
__exportStar(require("./IWebsocketMessageFormatter.js"), exports);
__exportStar(require("./List.js"), exports);
__exportStar(require("./PlatformEvent.js"), exports);
__exportStar(require("./Promise.js"), exports);
__exportStar(require("./Queue.js"), exports);
__exportStar(require("./RawWebsocketMessage.js"), exports);
__exportStar(require("./RiffPcmEncoder.js"), exports);
__exportStar(require("./Stream.js"), exports);
var TranslationStatus_js_1 = require("../common.speech/TranslationStatus.js");
Object.defineProperty(exports, "TranslationStatus", { enumerable: true, get: function () { return TranslationStatus_js_1.TranslationStatus; } });
__exportStar(require("./ChunkedArrayBufferStream.js"), exports);
__exportStar(require("./IAudioDestination.js"), exports);
__exportStar(require("./Timeout.js"), exports);
__exportStar(require("./OCSPEvents.js"), exports);
__exportStar(require("./BackgroundError.js"), exports);

//# sourceMappingURL=Exports.js.map
